const Profile = () => {
    return (
        <div>프로필 공사중</div>
    );
};

export default Profile